<template>
  <div class="dashboard-page">
    <Header />
    <section role="main" class="empty">
      <div class="container">
        <div class="row">
          <!-- 1. Executive Profile -->
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box text-center">
              <template v-if="isLoadingExecutive">
                <h5 class="calibri-bold">Executive Profile</h5>   <!-- <div class="skeleton-title skeleton-loader mb-2"></div> -->
                <div class="skeleton-value skeleton-loader mb-2"></div>
                <div class="month mt-2 calibri">*10K+ Executive Profiles/Month</div>  <!-- <div class="skeleton-subtext skeleton-loader"></div> -->
              </template>
              <template v-else>
                <h5 class="calibri-bold">Executive Profile</h5>
                <!-- Animated count -->
                <CountUp class="value calibri-bold" :end-val="detail.executive" :duration="4" :separator="','" />
                <div class="month mt-2 calibri">*10K+ Executive Profiles/Month</div>
              </template>
            </div>
          </div>

          <!-- 2. Executive Moves -->
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box text-center">
              <template v-if="isLoadingExecutive">
                <h5 class="calibri-bold">Executive Moves</h5>   <!-- <div class="skeleton-title skeleton-loader mb-2"></div> -->
                <div class="skeleton-value skeleton-loader mb-2"></div>
                <div class="month mt-2 calibri">*5K+ Moves Tracked/Month</div>  <!-- <div class="skeleton-subtext skeleton-loader"></div> -->
              </template>
              <template v-else>
                <h5 class="calibri-bold">Executive Moves</h5>
                <!-- <div class="value calibri-bold">{{ detail.moves }}</div> -->
                <!-- Animated count -->
                <CountUp class="value calibri-bold" :end-val="detail.moves" :duration="4" :separator="','" />
                <div class="month mt-2 calibri">*5K+ Moves Tracked/Month</div>
              </template>
            </div>
          </div>

          <!-- 3. Company Profile -->
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box text-center">
              <template v-if="isLoadingExecutive">
                <h5 class="calibri-bold">Company Profile</h5>   <!-- <div class="skeleton-title skeleton-loader mb-2"></div> -->
                <div class="skeleton-value skeleton-loader mb-2"></div>
                <div class="month mt-2 calibri">*2K+ Company Profile/Month</div>  <!-- <div class="skeleton-subtext skeleton-loader"></div> -->
              </template>
              <template v-else>
                <h5 class="calibri-bold">Company Profile</h5>
                <!-- <div class="value calibri-bold">{{ detail.comapny }}</div> -->
                <!-- Animated count -->
                <CountUp class="value calibri-bold" :end-val="detail.company" :duration="4" :separator="','" />
                <div class="month mt-2 calibri">*2K+ Company Profile/Month</div>
              </template>
            </div>
          </div>

          <!-- 4. Deals -->
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box text-center">
              <template v-if="isLoadingExecutive">
                <h5 class="calibri-bold">Deals</h5>   <!-- <div class="skeleton-title skeleton-loader mb-2"></div> -->
                <div class="skeleton-value skeleton-loader mb-2"></div>
                <div class="month mt-2 calibri">*2K+ Deals/Month</div>  <!-- <div class="skeleton-subtext skeleton-loader"></div> -->
              </template>
              <template v-else>
                <h5 class="calibri-bold">Deals</h5>
                <!-- <div class="value calibri-bold">{{ detail.deals }}</div> -->
                <!-- Animated count -->
                <CountUp class="value calibri-bold" :end-val="detail.deals" :duration="4" :separator="','" />
                <div class="month mt-2 calibri">*2K+ Deals/Month</div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- Sentence search tabs (Executives, Companies, News, Deals) - they replace the global search bar below, which is kept commented out until the client signs off -->
      <SentenceSearch />

      <!-- <div class="global-search">
        <div class="container">
          <div class="col-lg-10 col-sm-10 mx-auto">
            <form class="form-search form-inline" @submit.prevent>
              <input
                type="text"
                class="search-query"
                v-model="searchQuery"
                :placeholder="dynamicPlaceholder"
                @input="searchChange"
                @keydown.enter="handleEnterKey"
              />
            </form>

            <ul v-if="searchprompts.length" class="autocomplete-list">
              <li
                v-for="(item, index) in searchprompts"
                :key="index"
                class="autocomplete-item"
                @click="selectSuggestion(item)"
              >
                <span class="search-icon">🔍</span>
                <div>
                  <div class="prompt-text">{{ item.prompt }}</div>
                  <div style="font-size: 11px; color: gray; margin-top: -5px; font-style: italic;">
                    {{ getRedirectNote(item) }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      <div class="container">
        <!--These 4 graphs are commented out as per the client's request. Because of the Global Search feature, we are calling 4 APIs in the mount function, which are currently commented out. -->
        <div class="row mt-4 d-none">
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box" style="height: 284px">
              <div class="graph-title calibri-bold" style="font-weight: bold">
                Executive Moves (YoY)
              </div>
              <canvas id="bar-chart" width="450" height="450" class="mt-3 ml-3">
              </canvas>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box" style="height: 284px">
              <div class="graph-title calibri-bold" style="font-weight: bold">
                Executive Moves / Day
              </div>
              <canvas
                id="bar-chart5"
                width="450"
                height="450"
                class="mt-3 ml-3"
              >
              </canvas>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box" style="height: 284px">
              <div class="graph-title calibri-bold" style="font-weight: bold">
                Executive Moves / Industry
              </div>
              <canvas
                id="bar-chart3"
                width="450"
                height="450"
                class="mt-3 ml-3"
              >
              </canvas>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3">
            <div class="sm-box" style="height: 284px">
              <div class="graph-title calibri-bold" style="font-weight: bold">
                Company Profile
              </div>
              <canvas
                id="bar-chart4"
                width="450"
                height="400"
                class="mt-3 ml-3"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Latest highlights: one labelled auto-scrolling row per category
           (executive moves, deals & transactions, then one row per signal topic) -->
      <div class="highlights">
        <!-- full-bleed instead of .container: the labels sit near the left edge
             so the band has no dead gutter and the cards run to the right edge -->
        <div class="highlights-inner">
          <div class="hl-rows">
            <div
              v-for="(row, rowIndex) in highlightRows"
              :key="row.key"
              class="hl-row"
              :class="'hl-row-' + row.type.toLowerCase()"
            >
              <div class="hl-row-label">
                <span class="hl-row-mark"></span>
                {{ row.label }}
              </div>

              <!-- loading: same card frame, so the row height never jumps -->
              <div v-if="isLoadingHighlights" class="highlights-viewport">
                <div class="highlights-track">
                  <div v-for="n in 4" :key="n" class="hl-card hl-card-skeleton">
                    <div class="hl-brand">
                      <div class="hl-logo-tile skeleton-loader"></div>
                    </div>
                    <div class="hl-main">
                      <div class="skeleton-line skeleton-loader" style="width: 45%"></div>
                      <div class="skeleton-line skeleton-loader" style="width: 85%"></div>
                      <div class="skeleton-line skeleton-loader" style="width: 60%"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="row.cards.length" class="highlights-viewport">
                <div class="highlights-track" :style="trackStyle(row, rowIndex)">
                  <div
                    v-for="(card, index) in row.loopedCards"
                    :key="index"
                    class="hl-card"
                    :class="[
                      'hl-' + card.type.toLowerCase(),
                      { 'hl-clickable': card.route },
                    ]"
                    @click="openCard(card)"
                  >
                    <span class="hl-stripe"></span>
                    <span class="hl-glow"></span>

                    <div class="hl-brand">
                      <!-- .stop so the logo opens the company profile instead of
                           also firing the card's own navigation; cards with no
                           company fall through to the card click -->
                      <span
                        v-if="card.company_id"
                        class="hl-logo-tile hl-logo-link"
                        :title="card.company_name"
                        @click.stop="openCompany(card)"
                      >
                        <img class="hl-logo" :src="card.logo" alt="" @error="onLogoError" />
                      </span>
                      <span v-else class="hl-logo-tile" :title="card.company_name">
                        <img class="hl-logo" :src="card.logo" alt="" @error="onLogoError" />
                      </span>
                    </div>

                    <div class="hl-main">
                      <!-- the record's own type (move type / deal type);
                           signals have none, so only the date shows -->
                      <div class="hl-meta">
                        <!-- .stop so the type reads as a plain label instead of
                             opening the card like the rest of the surface -->
                        <span
                          class="hl-type"
                          v-if="card.label"
                          :title="card.label"
                          @click.stop
                        >
                          {{ card.label }}
                        </span>
                        <span class="hl-date">{{ card.date }}</span>
                      </div>
                      <div class="hl-person">
                        <div class="hl-person-text">
                          <div class="hl-title" v-if="card.title" :title="card.title">
                            {{ card.title }}
                          </div>
                          <div class="hl-sub" v-if="card.subtitle" :title="card.subtitle">
                            {{ card.subtitle }}
                          </div>
                        </div>
                        <!-- executive moves only: the person, sitting right of
                             their name and title -->
                        <img
                          v-if="card.avatar"
                          class="hl-avatar"
                          :src="card.avatar"
                          :title="card.title"
                          alt=""
                          @error="onAvatarError"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="hl-empty">No records</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <p>&nbsp;</p>
    <ErrorComponent @retry="getDetail(0)" ref="errorComponent" />
    <Footer />
  </div>
</template>
<script>
import Chart from "chart.js/auto";
import Header from "@/components/Header";
import ErrorComponent from "@/components/ErrorComponent";
import Footer from "@/components/Footer";
import SentenceSearch from "@/components/SentenceSearch";
import axios from "axios";
import moment from "moment";
import CountUp from 'vue-countup-v3';   // npm install vue-countup-v3 --legacy-peer-deps

const CARD_PITCH = 380;   // card width (366) + track gap (14) - keep in sync with .hl-card
const FALLBACK_LOGO = "/img/company.png";
const FALLBACK_AVATAR = "/img/user-pic.png";
// px per second per row - deliberately uneven so the rows never scroll in
// lockstep; the list repeats if the API ever returns more signal groups
const ROW_SPEEDS = [92, 118, 74, 104, 86, 130, 98, 112];
// move types as stored on tbl_company_news, labelled the way the news filters
// spell them out
const MOVE_TYPE_LABELS = {
  arrival_departure: "Arrival / Departure",
  internal_move: "Internal Move",
  lay_off: "Lay Off",
  own_venture: "Own Venture",
  terminated: "Terminated",
  retirement: "Retirement",
};
export default {
  name: "Dashboard",
  components: {
    Header,
    ErrorComponent,
    Footer,
    CountUp,
    SentenceSearch,
    // Form,
    // Field,
    // Multiselect,
  },
  data() {
    return {
      loader: false,
      myChart: undefined,
      isLoadingAppointments: true,
      isLoadingSignals: true,
      isLoadingDeals: true,
      isLoadingExecutive: true,
      detail: { executive: 0, moves: 0, company: 0, deals: 0 },
      recent_appoinment: [],
      // [{ topic_id, topic_name, bites: [] }] - one scroller row per topic
      signalGroups: [],
      dealsTransaction: [],
      ExecutiveMoves: [],
      ExecutiveMovesPerDay: [],
      ExecutivePerIndustry: [],
      CompanyProfilePerIndustry: [],
      searchprompts: [],
      searchQuery: "",
      showDidYouMean: false,
      dynamicPlaceholder: "",
      placeholderList: [
        "Search Executives by Name, Industry, Country, Region, or Job Function",
        "Search Companies by Name, CompanyType, CompanySize, Country, or Region",
        "Search News by Type, Job Function, or Industry",
        "Search Listings by Executive, Company, Industry, or Job Function",
        "Search Deals by Type, Stage, Job Function, or Industry",
        "Search Interesting Facts by Topic, Industry, Deal Stage, or Region"
      ],
      placeholderIndex: 0,
      placeholderInterval: null,

    };
  },
  computed: {
    isLoadingHighlights() {
      return (
        this.isLoadingAppointments ||
        this.isLoadingDeals ||
        this.isLoadingSignals
      );
    },
    executiveCards() {
      return this.recent_appoinment.map((data) => ({
        type: "EXECUTIVE",
        label: this.moveTypeLabel(data.type),
        logo: data.company_logo || FALLBACK_LOGO,
        company_name: data.company_name,
        company_id: data.company_id,
        avatar: this.executiveAvatar(data),
        date: this.formatCardDate(data.news_date),
        title: data.executive_name,
        subtitle: data.exe_jobtitle,
        route: data.executive_id
          ? "/executive-detail/" + data.executive_id
          : "",
      }));
    },
    dealCards() {
      return this.dealsTransaction.map((data) => ({
        type: "DEAL",
        // the topic is what the product calls the deal type
        label: data.topic ? data.topic.topic_name : "",
        logo:
          data.primary_company && data.primary_company.company_logo
            ? data.primary_company.company_logo
            : FALLBACK_LOGO,
        company_name:
          data.primary_company && data.primary_company.company_name
            ? data.primary_company.company_name
            : "",
        company_id:
          data.primary_company && data.primary_company.company_id
            ? data.primary_company.company_id
            : null,
        date: this.formatCardDate(data.published_date),
        title: data.headline,
        subtitle: "",
        // no per-deal detail route exists, so the section listing is the target
        route: "/deals-transactions",
      }));
    },
    // the API already groups the bites per topic, so each group is one row
    signalRows() {
      return this.signalGroups.map((group) => ({
        key: "SIGNAL_" + group.topic_name,
        type: "SIGNAL",
        label: group.topic_name,
        cards: (group.bites || []).map((data) => ({
          type: "SIGNAL",
          // the row label already names the topic, so the card carries no chip
          label: "",
          logo:
            data.company && data.company.company_logo
              ? data.company.company_logo
              : FALLBACK_LOGO,
          company_name:
            data.company && data.company.company_name
              ? data.company.company_name
              : "",
          company_id:
            data.company_id || (data.company ? data.company.id : null),
          date: this.formatCardDate(data.published_date),
          title: data.bites,
          subtitle: "",
          // no per-bite detail route exists, so the section listing is the target
          route: "/interesting-bites",
        })),
      }));
    },
    // one auto-scrolling row per label: executive moves, deals, then signals
    highlightRows() {
      const rows = [
        {
          key: "EXECUTIVE",
          type: "EXECUTIVE",
          label: "Executive Moves",
          cards: this.executiveCards,
        },
        {
          key: "DEAL",
          type: "DEAL",
          label: "Deals & Transactions",
          cards: this.dealCards,
        },
        ...this.signalRows,
      ];
      // each set is rendered twice so the marquee loops without a visible seam
      return rows.map((row) => ({
        ...row,
        loopedCards: [...row.cards, ...row.cards],
      }));
    },
  },
  beforeUnmount() {
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval);
    }
  },
  mounted() {
    // this.dynamicPlaceholderForGlobalSearch(); // global search bar is replaced by the sentence search tabs
    this.getDetail();
    this.getRecentAppointment();
    this.getSignals();
    this.getDealsTransaction();
    /* <!--These 4 graphs are commented out as per the client's request. Because of the Global Search feature, we are calling 4 APIs in the mount function, which are currently commented out. -->
    this.getExecutiveMoveByYear();
    this.getExecutiveMoveByDay();
    this.getExecutiveMoveByIndustry();
    this.getCompanyProfilePerIndustry();
    */
  },
  methods: {
    formatCardDate(date) {
      return date ? moment(date).format("D MMMM, YYYY") : "";
    },
    onLogoError(event) {
      if (event.target.src.indexOf(FALLBACK_LOGO) === -1) {
        event.target.src = FALLBACK_LOGO;
      }
    },
    onAvatarError(event) {
      if (event.target.src.indexOf(FALLBACK_AVATAR) === -1) {
        event.target.src = FALLBACK_AVATAR;
      }
    },
    // same fallback chain the executive listing uses, so a face on the
    // dashboard matches the one on the profile
    executiveAvatar(data) {
      if (data.executive_logo) {
        return data.executive_logo;
      }
      if (data.gender === "male") {
        return "/img/male.png";
      }
      if (data.gender === "female") {
        return "/img/female.png";
      }
      return FALLBACK_AVATAR;
    },
    // unknown values still read as a label instead of a raw db string
    moveTypeLabel(type) {
      if (!type) {
        return "";
      }
      return (
        MOVE_TYPE_LABELS[type] ||
        String(type).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
      );
    },
    // each row gets its own speed, so they drift apart instead of scrolling as
    // one block; the duration is what that speed works out to for its card count
    trackStyle(row, rowIndex) {
      const speed = ROW_SPEEDS[rowIndex % ROW_SPEEDS.length];
      const duration = (row.cards.length * CARD_PITCH) / speed;
      return {
        animationDuration: duration + "s",
        animationDelay: "-" + rowIndex * 3 + "s",
      };
    },
    // The router guard bounces unauthenticated users of protected routes back
    // to /dashboard, so the login redirect has to be decided here instead.
    openProtected(route) {
      if (!route) {
        return;
      }
      if (!localStorage.getItem("token")) {
        this.$router.push("/login");
        return;
      }
      this.$router.push(route);
    },
    openCard(card) {
      this.openProtected(card.route);
    },
    // logos stay inside ExecLibrary - the company profile, never the company's
    // own website
    openCompany(card) {
      this.openProtected(
        card.company_id ? "/company-detail/" + card.company_id : ""
      );
    },
    dynamicPlaceholderForGlobalSearch() {
      this.dynamicPlaceholder = this.placeholderList[0];
      this.placeholderInterval = setInterval(() => {
        this.placeholderIndex = (this.placeholderIndex + 1) % this.placeholderList.length;
        this.dynamicPlaceholder = this.placeholderList[this.placeholderIndex];
      }, 3000); // Change every 3 seconds
    },
    getExecutiveMoveByDay() {
      this.$api
        .getAPI({
          _action: "/executive/moves/day",
        })
        .then((res) => {
          this.ExecutiveMovesPerDay = res;
          this.getGraphExecutiveMoveByDay();
        })
        .catch(() => {});
    },
    getGraphExecutiveMoveByDay() {
      this.labelsArr = [];
      this.revanueArr = [];

      for (var i = 0; i < this.ExecutiveMovesPerDay.length; i++) {
        var month_name = this.$helperService.getText2(
          this.ExecutiveMovesPerDay[i].title.toUpperCase()
        );
        this.labelsArr.push(month_name);
        var revanue = this.ExecutiveMovesPerDay[i].count;
        this.revanueArr.push(revanue);
      }
      if (this.sales) {
        this.sales.destroy();
      }
      const ctx = document.getElementById("bar-chart5").getContext("2d");
      // var t = this;
      this.myChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.labelsArr,
          datasets: [
            {
              data: this.revanueArr,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderColor: "#87CEEB",
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: {
                display: true,
              },
              ticks: {
                display: false,
                // callback: function (label) {
                //   return t.$helperService.abbreviateNumber(label);
                // },
              },
            },
            x: {
              display: false,
            },
          },
        },
      });
    },

    getExecutiveMoveByIndustry() {
      this.$api
        .getAPI({
          _action: "/executive/moves/industry",
        })
        .then((res) => {
          this.ExecutivePerIndustry = res;
          this.getGraphExecutiveMoveByIndustry();
        })
        .catch(() => {});
    },
    getGraphExecutiveMoveByIndustry() {
      this.labelsArr = [];
      this.revanueArr = [];

      for (var i = 0; i < this.ExecutivePerIndustry.length; i++) {
        var industry_name = this.ExecutivePerIndustry[i].industry_name;
        this.labelsArr.push(industry_name);
        var revanue = this.ExecutivePerIndustry[i].count;
        this.revanueArr.push(revanue);
      }
      if (this.sales) {
        this.sales.destroy();
      }
      const ctx = document.getElementById("bar-chart3").getContext("2d");
      // var t = this;
      this.myChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.labelsArr,
          datasets: [
            {
              data: this.revanueArr,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
                "rgba(72, 245, 66)",
                "rgba(52, 235, 156)",
                "rgba(235, 52, 235)",
                "rgba(220, 235, 52)",
              ],
              borderColor: "#87CEEB",
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
        },
      });
    },
    searchChange(event) {
      const term = event.target.value;

      if (!term) {
        this.searchprompts = [];
        return;
      }

      this.getSearchPrompts(term);
    },
    getSearchPrompts(term) {
      // this.$api
      //   .postAPI({
      //     _action: "/prompts/suggest",
      //     _body: { term: term }
      //   })
      //   .then((res) => {
      //     if (res?.status === 'success' && Array.isArray(res.res)) {
      //       this.searchprompts = res.res;
      //       console.log("Search prompts:", res.res);
      //     } else {
      //       this.searchprompts = [];
      //     }
      //   })
      //   .catch((err) => {
      //     console.error("Prompt fetch error:", err);
      //     this.searchprompts = [];
      //   });
      axios
        .post("https://globalsearch-qa.execlibrary.com/hybrid", { q: term })   // http://127.0.0.1:5000 // https://devglobalsearch-qa.execlibrary.com // https://globalsearch-qa.execlibrary.com
        .then((res) => {
          this.searchprompts = res.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          this.searchprompts = [];
        });
    },
    submitSearch(item) {
      item = this.addExtraInfoToMetaData(item); // Adding prompt to meta and news type conditionally
      console.log("hyy", item); // temp added ???

      // If meta is missing, exit early
      if (!item) {
        console.warn("Invalid item: meta missing");
        return;
      }

      this.$shareService.setMapValue("global_search_filter", item.meta);
      const isLogin = localStorage.getItem("token");
    if(isLogin){
      if (item?.redirect_type === "executive") {
        this.$router.push("/executive/");

      } else if (item.redirect_type === "company") {
        this.$router.push("/company/");

      } else if (item.redirect_type === "news") { // Redirect on news
        this.$router.push("/news/");

      } else if (item.redirect_type === "deals") {
        this.$router.push("/deals-transactions/");

      } else if (item.redirect_type === "cluster_listing") { // Redirect on listing detail
        this.$router.push('/listing/');

      } else if (item.redirect_type === "bites") {
        this.$router.push("/interesting-bites/");

      } else if (item.redirect_type === "company_details" && item?.meta?.cid) {
        this.$router.push("/company-detail/" + item.meta.cid);

      } else {
        this.$router.push("/company/"); // temp added ???
      }

    }else{
      this.$router.push("/login");
    }
      
    },
    addExtraInfoToMetaData(item) {

      if (!item?.meta) {
        return false;
      }

      // Inject the prompt into meta
      if (item.prompt) {
        item.meta.prompt = item.prompt;
      }

      return item;
    },
    handleEnterKey() {
      if (this.searchprompts.length > 0) {
        const firstSuggestion = this.searchprompts[0];
       firstSuggestion.meta.flag = true;
        this.submitSearch(firstSuggestion); // this calls submitSearch internally
      } else {
        // Optional fallback if no suggestions exist
        console.warn("No suggestions available.");
      }
    },
    getRedirectNote(item) { // Client removed this feature but, i keep this for the development(debugging purpose). (you can look if uncomment this code(div): getRedirectNote(item) }})
      if (item.redirect_type === "executive") {
        return "Found in executive(s)";
      } else if (item.redirect_type === "company") {
        return "Found in company(s)";
      } else if (item.redirect_type === "bites") {
        return "Found in interesting-bite(s)";
      } else if (item.redirect_type === "deals") {
        return "Found in deals-transaction(s)";
      } else if (item.redirect_type === "news") {
        return "Found in news(s)";
      } else if (item.redirect_type === "cluster_listing") {
        return "Found in listing(s)";
      } else if (item.redirect_type == 'company_details') {
        return "Company-Detail";
      }
    },
    selectSuggestion(item) {
      this.searchQuery = item.prompt;
      item.meta.flag = false;

      // this.searchprompts = [];
      this.submitSearch(item);
    },
    getExecutiveMoveByYear() {
      this.$api
        .getAPI({
          _action: "/executive/moves/year",
        })
        .then((res) => {
          this.ExecutiveMoves = res;
          this.getGraphExecutiveMoveByYear();
        })
        .catch(() => {});
    },
    getGraphExecutiveMoveByYear() {
      this.labelsArr = [];
      this.revanueArr = [];

      for (var i = 0; i < this.ExecutiveMoves.length; i++) {
        var month_name =
          this.$helperService.getText2(
            this.ExecutiveMoves[i].month.toUpperCase(),
            3
          ) +
          "-" +
          this.ExecutiveMoves[i].year;
        this.labelsArr.push(month_name);
        var revanue = this.ExecutiveMoves[i].count;
        this.revanueArr.push(revanue);
      }
      if (this.sales) {
        this.sales.destroy();
      }
      const ctx = document.getElementById("bar-chart").getContext("2d");
      // var t = this;
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.labelsArr,
          datasets: [
            {
              data: this.revanueArr,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderColor: "#87CEEB",
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: {
                display: true,
              },
              ticks: {
                // callback: function (label) {
                //   return t.$helperService.abbreviateNumber(label);
                // },
                display: false,
              },
            },
            x: {
              display: false,
            },
            // x: {
            //   grid: {
            //     display: false,
            //   },
            // },
          },
        },
      });
    },
    getCompanyProfilePerIndustry() {
      // this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({
          _action: "/company/profile/industry",
        })
        .then((res) => {
          this.CompanyProfilePerIndustry = res;
          this.getGraphCompanyProfilePerIndustry();
          this.loader = false;
          // if (this.$refs.errorComponent) {
          //   this.$refs.errorComponent.updateFormLoader(false);
          // }
        })
        .catch(() => {
          this.loader = false;
          // if (this.$refs.errorComponent) {
          //   this.$refs.errorComponent.updateFormLoader(false);
          // }
        });
    },
    getGraphCompanyProfilePerIndustry() {
      this.labelsArr = [];
      this.revanueArr = [];

      for (var i = 0; i < this.CompanyProfilePerIndustry.length; i++) {
        var industry_name = this.CompanyProfilePerIndustry[i].industry_name;
        this.labelsArr.push(industry_name);
        var revanue = this.CompanyProfilePerIndustry[i].count;
        this.revanueArr.push(revanue);
      }
      if (this.sales) {
        this.sales.destroy();
      }
      const ctx = document.getElementById("bar-chart4").getContext("2d");
      this.myChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.labelsArr,
          datasets: [
            {
              data: this.revanueArr,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
                "rgba(72, 245, 66)",
                "rgba(235, 52, 235)",
                "rgba(52, 235, 156)",
                "rgba(220, 235, 52)",
              ],
              borderColor: "#87CEEB",
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
        },
      });
    },
    getDetail() {
      this.isLoadingExecutive = true;
      this.$api
        .getAPI({
          _action: "/dashboard",
        })
        .then((res) => {
          this.detail = res;
          this.isLoadingExecutive = false;
        })
        .catch(() => {
          this.isLoadingExecutive = false;
        });
    },
    getRecentAppointment() {
      this.$api
        .getAPI({
          _action: "/recent/appointment",
        })
        .then((res) => {
          this.recent_appoinment = res;
          this.isLoadingAppointments = false;
        })
        .catch(() => {
          this.isLoadingAppointments = false;
        });
    },
    getSignals() {
      this.$api
        .getAPI({
          _action: "/dashboard/signals",
        })
        .then((res) => {
          this.signalGroups = Array.isArray(res) ? res : [];
          this.isLoadingSignals = false;
        })
        .catch(() => {
          this.isLoadingSignals = false;
        });
    },
    getDealsTransaction() {
      this.$api
        .getAPI({
          _action: "/deals_and_transaction",
        })
        .then((res) => {
          this.dealsTransaction = res;
          this.isLoadingDeals = false;
        })
        .catch(() => {
          this.isLoadingDeals = false;
        });
    },
  },
};
</script>
<style scoped>
/* =========================================================================
   Page surface - the whole dashboard sits on the same dotted band the
   highlights used to carry on its own. The search bar keeps its white
   background, so it reads as a break in the surface.
   ========================================================================= */
.dashboard-page {
  --ink: #101828;
  --ink-soft: #667085;
  --band: #eaeef3;
  --font-b: "Calibri Bold", "Segoe UI", system-ui, sans-serif;
  --font-r: "Calibri Regular", "Segoe UI", system-ui, sans-serif;

  min-height: 100vh;
  background-color: var(--band);
  /* dot-grid texture so the page reads as its own surface, not just a tint.
     the offset lands a row of dots just under the fixed header, so the strip
     there is not a blank band */
  background-image: radial-gradient(rgba(27, 36, 48, 0.07) 1px, transparent 1px);
  background-size: 18px 18px;
  background-position: 0 9px;
}

/* =========================================================================
   Above-the-fold trim - scoped overrides of the shared .sm-box /
   .global-search rules, so the counters, the search bar and the highlights
   band all fit on one screen. Only this page is affected.
   ========================================================================= */
/* .empty's 80px top margin is the clearance for the fixed header. The desktop
   navbar is ~67px, so 72px closes the strip under it without letting the
   counters slide underneath. Mobile keeps the 80px - its navbar is taller. */
@media (min-width: 768px) {
  .empty {
    margin-top: 72px;
  }
}

.sm-box {
  padding: 10px 12px;
}

.sm-box h5 {
  margin-bottom: 2px;
  font-size: 16px;
}

.sm-box .value {
  font-size: 20px;
  line-height: 24px;
}

.sm-box .month {
  font-size: 12.5px;
}

.global-search {
  margin-top: 16px;
  padding: 22px 0;
}

/* ---- Global search autocomplete (unchanged) ---- */
.autocomplete-wrapper {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}

.search-input {
  width: 100%;
  padding: 10px 16px;
  font-size: 16px;
  border-radius: 25px;
  border: 1px solid #ccc;
  outline: none;
}

.autocomplete-list {
  /* position: absolute; */
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-top: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 0 0 10px 10px;
  z-index: 999;
  max-height: 300px;
  overflow-y: auto;
}

.autocomplete-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.autocomplete-item:hover {
  background-color: #f0f0f0;
}

.search-icon {
  margin-right: 10px;
  color: #888;
}

.prompt-text {
  flex: 1;
  font-size: 14px;
  color: #333;
}

/* =========================================================================
   Highlights rail - the auto-scrolling "live wire" band
   ========================================================================= */
/* no background of its own any more - it shares the page surface; overflow
   keeps the full-bleed rows clipped to the viewport */
.highlights {
  position: relative;
  padding: 6px 0 14px;
  overflow: hidden;
}

/* warm glow bleeding in from the top edge */
.highlights::before {
  content: "";
  position: absolute;
  top: -160px;
  left: 50%;
  width: 900px;
  height: 300px;
  margin-left: -450px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(222, 74, 56, 0.13) 0%,
    rgba(222, 74, 56, 0) 70%
  );
  pointer-events: none;
}

/* left gutter only - the rows keep running into the right edge of the band */
.highlights-inner {
  position: relative;
  padding-left: 46px;
}

/* ---- one labelled row per category, stacked ---- */
.hl-row {
  position: relative;
  display: flex;
  align-items: center;
}

.hl-row + .hl-row {
  border-top: 1px solid rgba(16, 24, 40, 0.07);
}

.hl-row-label {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 0 0 186px;
  padding-right: 16px;
  font-family: var(--font-b);
  font-size: 14px;
  line-height: 1.3;
  color: var(--ink);
}

.hl-row-mark {
  flex: 0 0 auto;
  width: 6px;
  height: 6px;
  background: #cbd5e1;
  border-radius: 50%;
}

.hl-row-executive .hl-row-mark {
  background: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.16);
}

.hl-row-deal .hl-row-mark {
  background: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16);
}

.hl-row-signal .hl-row-mark {
  background: #d97706;
  box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.16);
}

.hl-empty {
  flex: 1 1 auto;
  padding: 33px 0;
  font-family: var(--font-r);
  font-size: 13px;
  color: var(--ink-soft);
}

/* ---- viewport ---- */
.highlights-viewport {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  padding: 7px 0;
  overflow: hidden;
  /* mask (not a gradient overlay) so the fade works over the dotted texture */
  mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 34px,
    #000 calc(100% - 110px),
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 34px,
    #000 calc(100% - 110px),
    transparent 100%
  );
}

.highlights-track {
  display: flex;
  align-items: stretch;
  width: max-content;
  will-change: transform;
  animation-name: hl-scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* the card set is rendered twice, so -50% is exactly one full set */
@keyframes hl-scroll {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(-50%, 0, 0);
  }
}

.highlights-viewport:hover .highlights-track {
  animation-play-state: paused;
}

/* ---- card ----
   width + margin must stay in sync with CARD_PITCH in the script */
.hl-card {
  position: relative;
  flex: 0 0 366px;
  width: 366px;
  height: 90px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 10px 13px 10px 21px;
  margin-right: 14px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(16, 24, 40, 0.07);
  border-radius: 15px;
  box-shadow: 0 8px 20px -14px rgba(16, 24, 40, 0.45);
  transition: transform 0.28s ease, box-shadow 0.28s ease,
    border-color 0.28s ease;
}

.hl-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 34px -18px rgba(16, 24, 40, 0.5);
}

.hl-clickable {
  cursor: pointer;
}

/* inset pill instead of a full-height border - reads as a marker, not a rule */
.hl-stripe {
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 8px;
  width: 4px;
  background: #cbd5e1;
  border-radius: 999px;
}

/* type-tinted bloom in the top-right corner */
.hl-glow {
  position: absolute;
  top: -70px;
  right: -50px;
  width: 190px;
  height: 190px;
  border-radius: 50%;
  opacity: 0.55;
  pointer-events: none;
  transition: opacity 0.28s ease;
}

.hl-card:hover .hl-glow {
  opacity: 1;
}

.hl-executive .hl-stripe {
  background: linear-gradient(180deg, #4ade80, #15803d);
}

.hl-executive .hl-glow {
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(34, 197, 94, 0.22) 0%,
    rgba(34, 197, 94, 0) 72%
  );
}

.hl-executive:hover {
  border-color: rgba(34, 197, 94, 0.45);
}

.hl-deal .hl-stripe {
  background: linear-gradient(180deg, #818cf8, #4338ca);
}

.hl-deal .hl-glow {
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(99, 102, 241, 0.22) 0%,
    rgba(99, 102, 241, 0) 72%
  );
}

.hl-deal:hover {
  border-color: rgba(99, 102, 241, 0.45);
}

.hl-signal .hl-stripe {
  background: linear-gradient(180deg, #fbbf24, #b45309);
}

.hl-signal .hl-glow {
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(245, 158, 11, 0.24) 0%,
    rgba(245, 158, 11, 0) 72%
  );
}

.hl-signal:hover {
  border-color: rgba(245, 158, 11, 0.5);
}

/* ---- logo ---- */
.hl-brand {
  position: relative;
  flex: 0 0 72px;
  margin-right: 11px;
}

.hl-logo-tile {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 48px;
  padding: 5px;
  background: #fff;
  border: 1px solid #eceff3;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  transition: border-color 0.25s ease, transform 0.25s ease;
}

.hl-card:hover .hl-logo-tile {
  transform: scale(1.03);
}

/* only set when the card has a company to open, so it doubles as the
   "this logo is clickable" affordance */
.hl-logo-link {
  cursor: pointer;
}

.hl-logo-link:hover {
  border-color: #cbd2dc;
  box-shadow: 0 6px 14px -6px rgba(16, 24, 40, 0.35);
}

/* height:auto + max-height keeps wide logos full width and squarish logos
   from overflowing the tile */
.hl-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* name + title on the left, the executive's face on the right */
.hl-person {
  display: flex;
  align-items: center;
  gap: 9px;
}

.hl-person-text {
  flex: 1 1 auto;
  min-width: 0;
}

/* executive moves only */
.hl-avatar {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  object-fit: cover;
  background: #fff;
  border: 1px solid #eceff3;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.14);
  transition: transform 0.25s ease;
}

.hl-card:hover .hl-avatar {
  transform: scale(1.06);
}

/* ---- content ---- */
.hl-main {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.hl-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 3px;
}

/* move type / deal type - plain text, the way the deal topic used to read
   underneath the headline */
.hl-type {
  min-width: 0;
  cursor: default;
  font-family: var(--font-r);
  font-size: 11.5px;
  line-height: 1.3;
  color: #98a2b3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* margin-left keeps the date on the right even on cards with no type */
.hl-date {
  margin-left: auto;
  font-family: var(--font-r);
  font-size: 11.5px;
  color: #98a2b3;
  white-space: nowrap;
}

/* executive name / deal headline: one line only */
.hl-title {
  font-family: var(--font-b);
  font-size: 14px;
  line-height: 1.3;
  color: var(--ink);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hl-sub {
  margin-top: 1px;
  font-family: var(--font-r);
  font-size: 12.5px;
  line-height: 1.3;
  color: #475467;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* signals carry the whole bite in the title, so it reads as body copy */
.hl-signal .hl-title {
  font-family: var(--font-r);
  font-size: 12.5px;
  line-height: 1.38;
  color: #344054;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

/* signals have no chip, so the bite gets the room the meta row would use */
.hl-signal .hl-meta {
  margin-bottom: 3px;
}

/* ---- loading ---- */
.skeleton-loader {
  background: linear-gradient(90deg, #e0e0e0 25%, #f8f8f8 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: loading 1.2s ease-in-out infinite;
  border-radius: 4px;
  margin: 0 auto;
}

.skeleton-title {
  width: 140px;
  height: 20px;
}

/* matches the counter's line-height, so the box does not resize once the
   number loads */
.skeleton-value {
  width: 80px;
  height: 20px;
}

.skeleton-subtext {
  width: 160px;
  height: 16px;
}

.hl-card-skeleton {
  align-items: flex-start;
  padding-top: 18px;
}

.hl-card-skeleton .hl-logo-tile {
  border: 0;
  box-shadow: none;
}

.skeleton-line {
  height: 12px;
  margin: 0 0 10px;
  border-radius: 6px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* ---- responsive ---- */
@media (max-width: 767px) {
  .highlights {
    margin-top: 20px;
    padding: 18px 0 14px;
  }

  .highlights-inner {
    padding-left: 16px;
  }

  .hl-row {
    display: block;
  }

  .hl-row-label {
    padding: 14px 0 0;
  }

  .highlights-viewport {
    margin-left: -16px;
    mask-image: linear-gradient(
      90deg,
      transparent 0,
      #000 30px,
      #000 calc(100% - 30px),
      transparent 100%
    );
    -webkit-mask-image: linear-gradient(
      90deg,
      transparent 0,
      #000 30px,
      #000 calc(100% - 30px),
      transparent 100%
    );
  }
}
</style>
